import { Link } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";

// Standard marketing shell with full nav.
// Pass `focused={true}` for a stripped-back sales page shell that ONLY shows
// the logo (linking home) in the top-left — no nav tabs. Used by sales pages
// that want zero navigational distraction during the decision flow.
export default function MarketingLayout({ children, focused = false }) {
  return (
    <div className="bg-cream min-h-screen flex flex-col">
      {focused ? (
        <header
          className="bg-cream/95 backdrop-blur sticky top-0 z-40 border-b border-hairline"
          data-testid="focused-header"
        >
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 md:py-5">
            <Link
              to="/"
              className="inline-flex items-baseline font-serif-display text-2xl md:text-[1.7rem] text-ink hover:text-vibrant-dark transition"
              data-testid="focused-header-logo"
            >
              Pip<span className="text-gold italic ml-1.5"> Bennett</span>
            </Link>
          </div>
        </header>
      ) : (
        <Navigation />
      )}
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
